import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import {
  getDefaultLocale,
  persistUserLocale,
  resolveLocaleForRuntime,
  SUPPORTED_LOCALES,
  type SupportedLocale,
} from "@/services/localeResolver";
import hrApp from "@/locales/hr/app.json";
import enApp from "@/locales/en/app.json";
import deApp from "@/locales/de/app.json";
import esApp from "@/locales/es/app.json";
import frApp from "@/locales/fr/app.json";
import itApp from "@/locales/it/app.json";
import hrCommon from "@/locales/hr/common.json";
import enCommon from "@/locales/en/common.json";
import deCommon from "@/locales/de/common.json";
import esCommon from "@/locales/es/common.json";
import frCommon from "@/locales/fr/common.json";
import itCommon from "@/locales/it/common.json";

const resources: Record<SupportedLocale, Record<string, Record<string, string>>> = {
  hr: {
    app: hrApp,
    common: hrCommon,
  },
  en: {
    app: enApp,
    common: enCommon,
  },
  de: {
    app: deApp,
    common: deCommon,
  },
  es: {
    app: esApp,
    common: esCommon,
  },
  fr: {
    app: frApp,
    common: frCommon,
  },
  it: {
    app: itApp,
    common: itCommon,
  },
};

const locale = resolveLocaleForRuntime();

void i18n.use(initReactI18next).init({
  resources,
  lng: locale,
  fallbackLng: getDefaultLocale(),
  supportedLngs: [...SUPPORTED_LOCALES],
  defaultNS: "app",
  ns: ["app", "common"],
  interpolation: { escapeValue: false },
  returnNull: false,
});

export const setUserLocale = async (localeCode: string): Promise<SupportedLocale> => {
  const localeToUse = persistUserLocale(localeCode);
  await i18n.changeLanguage(localeToUse);
  return localeToUse;
};

export default i18n;
